/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateScheduleDateDto } from '../../models/update-schedule-date-dto';

export interface EnrollmentScheduleGroupControllerUpdateDate$Params {
  groupId: string;
      body: UpdateScheduleDateDto
}

export function enrollmentScheduleGroupControllerUpdateDate(http: HttpClient, rootUrl: string, params: EnrollmentScheduleGroupControllerUpdateDate$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
  const rb = new RequestBuilder(rootUrl, enrollmentScheduleGroupControllerUpdateDate.PATH, 'patch');
  if (params) {
    rb.query('groupId', params.groupId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
    })
  );
}

enrollmentScheduleGroupControllerUpdateDate.PATH = '/api/enrollment-schedule-group/date';
